<template>
  <div>
    <el-alert
      title="留空单号时，维保工单、计划生成的维保单、物料需求和作业计划会按这里取号。规则停用后，这几处仍用原来的时间戳单号。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.ruleCode" clearable placeholder="规则编码" style="width:180px" @keyup.enter.native="search" />
      <el-input v-model="query.ruleName" clearable placeholder="名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="ruleCode" label="规则编码" width="200" />
      <el-table-column prop="ruleName" label="名称" min-width="140" />
      <el-table-column prop="prefix" label="前缀" width="90" />
      <el-table-column prop="datePattern" label="日期格式" width="110" />
      <el-table-column prop="seqLength" label="流水位" width="80" align="center" />
      <el-table-column prop="resetCycle" label="复位" width="90" align="center" />
      <el-table-column prop="currentSeq" label="当前流水" width="90" align="center" />
      <el-table-column prop="currentPeriod" label="当前周期" width="110" />
      <el-table-column label="启用" width="70" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.active === '1' ? 'success' : 'info'">{{ row.active === '1' ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="240" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="doPreview(row.ruleCode)">预览</el-button>
          <el-button type="text" @click="doNext(row.ruleCode)">取号</el-button>
          <el-button type="text" @click="openEdit(row.ruleId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.ruleId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog :title="form.ruleId ? '修改编号规则' : '新增编号规则'" :visible.sync="visible" width="520px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="规则编码"><el-input v-model="form.ruleCode" :disabled="!!form.ruleId" placeholder="如 MAINTENANCE_ORDER" /></el-form-item>
        <el-form-item label="名称"><el-input v-model="form.ruleName" /></el-form-item>
        <el-form-item label="前缀"><el-input v-model="form.prefix" placeholder="如 WO" /></el-form-item>
        <el-form-item label="日期格式">
          <el-select v-model="form.datePattern" clearable style="width:100%" placeholder="可不含日期">
            <el-option label="yyyyMMdd" value="yyyyMMdd" />
            <el-option label="yyyyMM" value="yyyyMM" />
            <el-option label="yyyy" value="yyyy" />
            <el-option label="无" value="" />
          </el-select>
        </el-form-item>
        <el-form-item label="流水位数"><el-input-number v-model="form.seqLength" :min="1" :max="12" style="width:100%" /></el-form-item>
        <el-form-item label="复位周期">
          <el-select v-model="form.resetCycle" style="width:100%">
            <el-option label="按日" value="DAY" />
            <el-option label="按月" value="MONTH" />
            <el-option label="按年" value="YEAR" />
            <el-option label="不复位" value="NONE" />
          </el-select>
        </el-form-item>
        <el-form-item label="启用"><el-switch v-model="form.active" active-value="1" inactive-value="0" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
        <el-form-item label="示例"><span style="color:#666">{{ example }}</span></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listNumberRule, getNumberRule, saveNumberRule, updateNumberRule, deleteNumberRule, previewNumberRule, nextNumberRule } from '../../api/numberRule'

function emptyForm() {
  return {
    ruleId: '', ruleCode: '', ruleName: '', prefix: '', datePattern: 'yyyyMMdd',
    seqLength: 4, resetCycle: 'DAY', active: '1', remark: ''
  }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { ruleCode: '', ruleName: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, saving: false, form: emptyForm()
    }
  },
  computed: {
    example() {
      const prefix = this.form.prefix || ''
      const now = new Date()
      const y = now.getFullYear()
      const mm = String(now.getMonth() + 1).padStart(2, '0')
      const dd = String(now.getDate()).padStart(2, '0')
      let date = ''
      if (this.form.datePattern === 'yyyyMMdd') date = '' + y + mm + dd
      else if (this.form.datePattern === 'yyyyMM') date = '' + y + mm
      else if (this.form.datePattern === 'yyyy') date = '' + y
      const len = this.form.seqLength || 4
      return prefix + date + String(1).padStart(len, '0')
    }
  },
  created() { this.load() },
  methods: {
    load() {
      this.loading = true
      listNumberRule({ ...this.query, currentPage: this.page, pageSize: this.pageSize }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      if (!id) return
      getNumberRule(id).then(res => { this.form = Object.assign(emptyForm(), res.data || {}) })
    },
    submit() {
      if (!this.form.ruleCode || !this.form.ruleName) { this.$message.warning('请填写规则编码和名称'); return }
      this.saving = true
      const req = this.form.ruleId ? updateNumberRule(this.form) : saveNumberRule(this.form)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.load()
      }).finally(() => { this.saving = false })
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteNumberRule([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    },
    doPreview(code) {
      previewNumberRule(code).then(res => {
        const number = (res.data || {}).number
        this.$alert('下一号预览：' + (number || '(无)'), '预览')
      })
    },
    doNext(code) {
      this.$confirm('确认消耗一个流水号？', '提示', { type: 'warning' }).then(() => {
        nextNumberRule(code).then(res => {
          this.$message.success('取号：' + ((res.data || {}).number || ''))
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
